// Mirrors the backend ImportValidationReviewDto (BEE123.Dto/Import): the latest dry-run's per-section verdicts
// plus the structured failures grouped by employee. Category is the ValidationFailureCategory enum value.
export namespace ValidationReview {

    export interface Dto {
        requestId: number,
        passed: boolean,
        validatedOn?: Date,
        sections: Section[],
        // One page of failing employees (ordered by name). totalEmployees is the full count for paging.
        employees: Employee[],
        totalEmployees: number,
        // File-level failures are paged separately via the unattributed endpoint; this is just their count.
        totalUnattributed: number,
    }

    // One page of file-level (unattributed) failures. Mirrors ValidationReviewFailurePageDto.
    export interface FailurePage {
        failures: Failure[],
        total: number,
    }

    export interface Section {
        name: string,
        passed: boolean,
        rowsCorrect: number,
        rowsFailed: number,
    }

    export interface Employee {
        stagingIndividualId: string,
        firstname: string,
        surname: string,
        employeeCode: string,
        idNumber: string,
        failures: Failure[],
    }

    export interface Failure {
        section: string,
        category: ValidationFailureCategory,
        field: string,
    }

    // Mirror of BEE123.Domain.Imports.ValidationFailureCategory.
    export enum ValidationFailureCategory {
        Unspecified = 0,
        Required = 1,
        InvalidValue = 2,
        InvalidDateRange = 3,
        NotFound = 4,
        Duplicate = 5,
    }
}
